import React, { useEffect, useState } from "react";
import "./homeProducts.css";
import axiosInstance from "../../apis/config";
import HomeProductsCard from "./homeProductsCard";
import { Link } from "react-router-dom";

const Phones = () => {
  const [products, setProducts] = useState([]);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    setShowSpinner(true);
    axiosInstance
      .get("/products/random-phones", {})
      .then((response) => {
        setProducts(response.data.data);
        setShowSpinner(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <section
      className="product-container"
      aria-labelledby="routers-heading"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <h2 id="routers-heading" className="sr-only">
        Networking Routers and Equipment in Nakuru, Kenya
      </h2>

      {showSpinner ? (
        <div
          className="container"
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        >
          <h3 className="title he-headers">Networking Routers</h3>
          <div className="product-grid">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="card"
                aria-hidden="true"
                itemScope
                itemType="https://schema.org/Product"
              >
                <div className="card-body">
                  <h4 className="card-title placeholder-glow">
                    <span className="placeholder col-6" itemProp="name"></span>
                  </h4>
                  <p className="card-text placeholder-glow">
                    <span
                      className="placeholder col-7"
                      itemProp="description"
                    ></span>
                    <span className="placeholder col-4"></span>
                    <span className="placeholder col-4"></span>
                    <span className="placeholder col-6"></span>
                    <span className="placeholder col-8"></span>
                  </p>
                  <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                    <span
                      className="placeholder col-4"
                      itemProp="offers"
                      itemScope
                      itemType="https://schema.org/Offer"
                    >
                      <meta itemProp="priceCurrency" content="KES" />
                      <span
                        itemProp="price"
                        className="placeholder col-4"
                      ></span>
                    </span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="product-main">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 className="title he-headers">
                <span itemProp="name">Networking Routers</span>
              </h3>
              <span
                style={{
                  fontSize: "12px",
                  color: "gray",
                  cursor: "pointer",
                  marginTop: "5px",
                }}
              >
                <Link
                  to={`/search?page=1&query=Networking+Routers`}
                  aria-label="Browse all networking routers and equipment in Nakuru"
                  itemProp="url"
                >
                  See All
                </Link>
              </span>
            </div>
            <div
              className="product-grid"
              itemScope
              itemType="https://schema.org/ItemList"
            >
              {products.map((product, index) => (
                <HomeProductsCard
                  key={product._id}
                  product={product}
                  itemScope
                  itemType="https://schema.org/Product"
                  itemProp="itemListElement"
                  position={index + 1}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Phones;
